import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-128">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" data-id="element-129">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="absolute inset-0 bg-[#2D2D2D]/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-130" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} role="dialog" aria-modal="true" aria-label={title} className="relative w-full max-w-2xl max-h-[85vh] bg-[#FDF8F3] rounded-2xl shadow-2xl flex flex-col overflow-hidden" data-id="element-131">
            {/* Header */}
            <div className="flex items-center justify-between px-6 md:px-8 pt-6 md:pt-8 pb-4 border-b border-[#F3EDF7]" data-id="element-132">
              <h2 className="font-['Playfair_Display'] text-xl md:text-2xl font-semibold text-[#2D2D2D]" data-id="element-133">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F3EDF7] text-[#4A4A4A] transition-colors hover:bg-[#B794C0] hover:text-white" data-id="element-134">
                <XIcon className="w-5 h-5" data-id="element-135" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-6 md:px-8 py-6 md:py-8" data-id="element-136">
              <div className="prose prose-sm max-w-none text-[#4A4A4A] leading-relaxed space-y-4" data-id="element-137">
                {children}
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 md:px-8 py-4 border-t border-[#F3EDF7]" data-id="element-138">
              <button onClick={onClose} className="w-full py-3 rounded-full bg-[#B794C0] text-white font-medium text-sm transition-colors hover:bg-[#a07db0]" data-id="element-139">
                Entendido
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}